import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const ChatGPTForStudents: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="ChatGPT for Students - AI Study Assistant | YouWo AI"
      metaDescription="Looking for ChatGPT for studying? YouWo AI is an AI study assistant that helps with notes, flashcards, quizzes, and lecture transcription. Built specifically for students."
      keywords="chatgpt for students, ai study assistant, chatgpt alternative students, ai homework help, ai learning tool, study with ai"
      canonicalUrl="https://youwo.ai/tools/chatgpt-for-students"
      // Hero
      headline="ChatGPT for Students: Your AI Study Companion"
      subheadline="ChatGPT is powerful but generic. YouWo AI is AI specifically designed for studying: transcribe lectures, create flashcards, generate quizzes, and ace your exams."
      heroIcon="lucide:graduation-cap"
      heroIconColor="text-indigo-500"
      heroIconBg="bg-indigo-50"
      // Problem/Solution
      problemTitle="ChatGPT Isn't Built for Studying"
      problemDescription="ChatGPT can answer questions, but it can't record your lectures, organize your notes, or track what you've learned. You're copy-pasting between apps instead of studying."
      solutionTitle="AI Built for Academic Success"
      solutionDescription="YouWo AI integrates AI throughout your study workflow: record lectures, upload PDFs, get summaries, create flashcards, take quizzes - all in one place designed for students."
      // Features (no competitor comparison for this page)
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Study in over 100 languages with automatic language detection.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Jump to any moment in recordings with clickable timestamps.",
        },
        {
          icon: "lucide:mic",
          title: "Lecture Recording",
          description: "Record classes and get AI transcriptions with key concepts highlighted.",
        },
        {
          icon: "lucide:layers",
          title: "Active Recall Flashcards",
          description: "AI creates flashcards using active recall - the most effective learning technique.",
        },
        {
          icon: "lucide:help-circle",
          title: "Practice Quizzes",
          description: "Generate practice tests from any material to prepare for exams.",
        },
        {
          icon: "lucide:youtube",
          title: "Video Learning",
          description: "Turn YouTube lectures and tutorials into study notes with timestamps.",
        },
      ]}
      // CTA
      ctaText="Start Studying Smarter"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
        { name: "AI Quiz Generator", href: "/tools/quiz-generator", icon: "lucide:help-circle" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
        { name: "Lecture Notes AI", href: "/tools/lecture-notes", icon: "lucide:graduation-cap" },
      ]}
    />
  );
};

export default ChatGPTForStudents;
